var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 6.287 9.79 5.953l-1.54-3.895h-.515l-1.54 3.895-3.938.332-.196.542 3.022 2.722-.92 4.052.448.341 3.381-2.171 3.346 2.148.478-.335L10.9 9.55l3.04-2.738-.19-.524Zm-1.74.882-2.94-.248L7.99 4.195 6.913 6.92l-2.941.248 2.243 2.02-.665 2.932 2.441-1.568 2.441 1.568-.665-2.932 2.244-2.02Z",
    fill: "currentColor"
  })));
};
export default SvgStar;